import Orders from 'modules/Admin/orders/Orders'

function OrdersPage() {
  return (
    <div data-testid="adminOrdersPage">
      <Orders />
    </div>
  )
}

export default OrdersPage
